import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-direction-in-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfDirectionInIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfDirectionInIcon(props: CcfDirectionInIconProps) {
  return (
    <SvgIcon
      {...props}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 8C16.5 8.44183 16.1418 8.8 15.7 8.8L8.03137 8.8L10.6657 11.4343C10.9781 11.7467 10.9781 12.2533 10.6657 12.5657C10.3533 12.8781 9.84673 12.8781 9.53431 12.5657L5.53431 8.56568C5.22189 8.25327 5.22189 7.74673 5.53431 7.43431L9.53431 3.43431C9.84673 3.1219 10.3533 3.1219 10.6657 3.43431C10.9781 3.74673 10.9781 4.25327 10.6657 4.56569L8.03137 7.2L15.7 7.2C16.1418 7.2 16.5 7.55817 16.5 8ZM6.9 0.8C6.9 1.24183 6.54183 1.6 6.1 1.6L5.14 1.6C4.45474 1.6 3.9889 1.60062 3.62883 1.63004C3.2781 1.6587 3.09874 1.71064 2.97362 1.77439C2.67256 1.92779 2.42779 2.17256 2.27439 2.47362C2.21064 2.59873 2.1587 2.7781 2.13004 3.12883C2.10062 3.4889 2.1 3.95474 2.1 4.64L2.1 11.36C2.1 12.0453 2.10062 12.5111 2.13004 12.8712C2.1587 13.2219 2.21064 13.4013 2.27439 13.5264C2.42779 13.8274 2.67256 14.0722 2.97362 14.2256C3.09874 14.2894 3.2781 14.3413 3.62883 14.37C3.9889 14.3994 4.45474 14.4 5.14 14.4L6.1 14.4C6.54183 14.4 6.9 14.7582 6.9 15.2C6.9 15.6418 6.54183 16 6.1 16L5.10694 16C4.46297 16 3.93149 16 3.49854 15.9646C3.04886 15.9279 2.6355 15.8491 2.24723 15.6512C1.64511 15.3444 1.15557 14.8549 0.84878 14.2528C0.650946 13.8645 0.572095 13.4511 0.535355 13.0015C0.499982 12.5685 0.49999 12.037 0.5 11.3931L0.500001 4.60694C0.49999 3.96297 0.499983 3.43149 0.535355 2.99854C0.572096 2.54886 0.650947 2.1355 0.848781 1.74723C1.15557 1.14511 1.64511 0.655574 2.24723 0.348779C2.6355 0.150947 3.04886 0.0720952 3.49854 0.0353551C3.9315 -1.88003e-05 4.46299 -1.03854e-05 5.10696 -1.52972e-07L6.1 2.71905e-07C6.54183 2.91218e-07 6.9 0.358173 6.9 0.8Z"
        fill="#829AAB"
      />
    </SvgIcon>
  );
}

export default CcfDirectionInIcon;
